// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__xIjqU","navigation__link":"Navigation_navigation__link__VWuPG","navigation-span":"Navigation_navigation-span__hTmEZ"};